"use strict";

(function () {
  // An object with options for the IntersectionObserver.

  if ($('#banner-navbar').length) {
    const options = {
      // 0.5 = The callback is fired when 50% of the element is visible
      // We can add more values to the array, like 0.25, 0.75 or 1.0
      threshold: [0.80]
    };

    // Instantiate the IntersectionObserver class
    const observer = new IntersectionObserver((entries, observer) => {
      // This is the callback.
      entries.forEach(entry => {
        // Checks if 50% or more of the element is visible in the viewport
        if (entry.intersectionRatio >= 0.80) {
          // Call the setCurrent function and pass the element (DOM-node)
          setCurrent(entry.target);
        }
      });
      // End of callback. Pass the options object as the second argument.
    }, options);
    const setCurrent = section => {
      // Finds all elements (<a> and <section>) with the .current class and remove it.
      document.querySelectorAll('.current').forEach(el => el.classList.remove('current'));

      // Add the .current class to the current <section>...
      section.classList.add('current');
      // ...and the current <a> in the navbar.
      document.querySelector(`.banner-navbar-menu a[href="#${section.id}"]`).classList.add('current');
    };

    // Query the DOM for all the sections...
    const sections = document.querySelectorAll('section');
    // Loop through them and tell our instance of the 
    // IntersectionObserver class to observe each one of them.
    sections.forEach(section => observer.observe(section));
  }
})();
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aXZlLW5hdi1vbi1zY3JvbGwuanMiLCJuYW1lcyI6WyIkIiwibGVuZ3RoIiwib3B0aW9ucyIsInRocmVzaG9sZCIsIm9ic2VydmVyIiwiSW50ZXJzZWN0aW9uT2JzZXJ2ZXIiLCJlbnRyaWVzIiwiZm9yRWFjaCIsImVudHJ5IiwiaW50ZXJzZWN0aW9uUmF0aW8iLCJzZXRDdXJyZW50IiwidGFyZ2V0Iiwic2VjdGlvbiIsImRvY3VtZW50IiwicXVlcnlTZWxlY3RvckFsbCIsImVsIiwiY2xhc3NMaXN0IiwicmVtb3ZlIiwiYWRkIiwicXVlcnlTZWxlY3RvciIsImlkIiwic2VjdGlvbnMiLCJvYnNlcnZlIl0sInNvdXJjZXMiOlsiYWN0aXZlLW5hdi1vbi1zY3JvbGwuanMiXSwibWFwcGluZ3MiOiI7O0FBQUEsQ0FBQyxZQUFZO0VBQ1Q7O0VBRUEsSUFBSUEsQ0FBQyxDQUFDLGdCQUFnQixDQUFDLENBQUNDLE1BQU0sRUFBRTtJQUU1QixNQUFNQyxPQUFPLEdBQUc7TUFDWjtNQUNBO01BQ0FDLFNBQVMsRUFBRSxDQUFDLElBQUk7SUFDcEIsQ0FBQzs7SUFFRDtJQUNBLE1BQU1DLFFBQVEsR0FBRyxJQUFJQyxvQkFBb0IsQ0FBQyxDQUFDQyxPQUFPLEVBQUVGLFFBQVEsS0FBSztNQUM3RDtNQUNBRSxPQUFPLENBQUNDLE9BQU8sQ0FBRUMsS0FBSyxJQUFJO1FBQ3RCO1FBQ0EsSUFBSUEsS0FBSyxDQUFDQyxpQkFBaUIsSUFBSSxJQUFJLEVBQUU7VUFDakM7VUFDQUMsVUFBVSxDQUFDRixLQUFLLENBQUNHLE1BQU0sQ0FBQztRQUM1QjtNQUNKLENBQUUsQ0FBQztNQUNIO0lBQ0osQ0FBQyxFQUFFVCxPQUFPLENBQUM7SUFFWCxNQUFNUSxVQUFVLEdBQUlFLE9BQU8sSUFBSztNQUM1QjtNQUNBQyxRQUFRLENBQUNDLGdCQUFnQixDQUFDLFVBQVUsQ0FBQyxDQUFDUCxPQUFPLENBQUVRLEVBQUUsSUFBS0EsRUFBRSxDQUFDQyxTQUFTLENBQUNDLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQzs7TUFFckY7TUFDQUwsT0FBTyxDQUFDSSxTQUFTLENBQUNFLEdBQUcsQ0FBQyxTQUFTLENBQUM7TUFDaEM7TUFDQUwsUUFBUSxDQUFDTSxhQUFhLENBQUMsZ0NBQWdDUCxPQUFPLENBQUNRLEVBQUUsSUFBSSxDQUFDLENBQUNKLFNBQVMsQ0FBQ0UsR0FBRyxDQUFDLFNBQVMsQ0FBQztJQUNuRyxDQUFDOztJQUVEO0lBQ0EsTUFBTUcsUUFBUSxHQUFHUixRQUFRLENBQUNDLGdCQUFnQixDQUFDLFNBQVMsQ0FBQztJQUNyRDtJQUNBO0lBQ0FPLFFBQVEsQ0FBQ2QsT0FBTyxDQUFFSyxPQUFPLElBQUtSLFFBQVEsQ0FBQ2tCLE9BQU8sQ0FBQ1YsT0FBTyxDQUFDLENBQUM7RUFFNUQ7QUFFSixDQUFDLEVBQUUsQ0FBQyIsImlnbm9yZUxpc3QiOltdfQ==
